module.exports = __webpack_public_path__ + "static/media/armor.a1495fd2.png";